import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	const [input4, onChangeInput4] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2890,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 89,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 310,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/aqlex4yj_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zlupvnhy_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9cov3z6u_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/86cadq7m_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9u46li5n_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2nybwl9t_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Chats"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bwnzhn7e_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tkf1eapw_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5qi6gp6g_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/eto39sv8_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wif1w6d6_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0bu0tawb_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zuldbms8_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wjhm79ay_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ma5uq6t7_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tlxylywh_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rkf81ht3_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input1}
								onChange={(event)=>onChangeInput1(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5eztqov3_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/evna2b40_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ubvaofce_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginBottom: 32,
							marginLeft: 267,
						}} >
						{"Contact Us"}
					</span>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 22,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Settings"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
									borderRadius: 12,
									padding: 20,
									marginBottom: 32,
									marginLeft: 2,
									marginRight: 2,
									gap: 16,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7x03fu2t_expires_30_days.png"} 
									style={{
										width: 58,
										height: 58,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 7,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											gap: 14,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 18,
												fontWeight: "bold",
											}} >
											{"Guy Hawkins"}
										</span>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 3,
												paddingTop: 1,
												paddingBottom: 1,
												paddingLeft: 6,
												paddingRight: 6,
											}}>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Mentee"}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 6,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7bxjqt2r_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"yourguy123@email.com"}
										</span>
									</div>
								</div>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 24,
									marginLeft: 2,
								}} >
								{"General Settings"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vxjms4to_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 225,
									}} >
									{"Edit Profile"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lfyekd0y_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2ke512xo_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 170,
									}} >
									{"Change Password"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5xoqacr4_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 62,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1f7sfj78_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 165,
									}} >
									{"Language Settings"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kjiath2m_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 24,
									marginLeft: 2,
								}} >
								{"Account & Security"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gbt4qhj2_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 176,
									}} >
									{"Account Settings"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6xvz1iiu_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 62,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7qyej2p5_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 34,
									}} >
									{"Manage Data & Sharing Permissions"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zh80rlu3_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 24,
									marginLeft: 2,
								}} >
								{"Notifications & Support"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/407ci0yn_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 153,
									}} >
									{"Notification Settings"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/w0r28l0j_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5pk1jnyl_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 192,
									}} >
									{"Help & Support"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cz8rzz10_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cy36u24w_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 276,
									}} >
									{"FAQ"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jt2zf06a_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 62,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2h9fur7j_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#1074BC",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 220,
									}} >
									{"Contact Us"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/d4pbb8no_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 24,
									marginLeft: 2,
								}} >
								{"Legal & Policies"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ljbtfjjm_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 179,
									}} >
									{"Terms of Service"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2dawniir_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0t57826x_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 201,
									}} >
									{"Privacy Policy"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ay6hlgk5_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginLeft: 2,
									marginRight: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9suxua09_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 16,
										marginRight: 236,
									}} >
									{"About Us"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/oaymc8xg_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1146,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 15,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 569,
									}} >
									{"Contact Us"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sk750x92_expires_30_days.png"} 
									style={{
										width: 10,
										height: 10,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 679,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 14,
									paddingBottom: 14,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pushvief_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search for answers..."}
									value={input2}
									onChange={(event)=>onChangeInput2(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 137,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 18,
									fontWeight: "bold",
									marginBottom: 20,
								}} >
								{"Contact Methods"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
									borderRadius: 12,
									paddingTop: 17,
									paddingBottom: 17,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4xvtzc6s_expires_30_days.png"} 
									style={{
										width: 40,
										height: 40,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Email Support"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"support@example.com"}
									</span>
								</div>
								<div 
									style={{
										width: 129,
										alignSelf: "stretch",
									}}>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lt6g8bnm_expires_30_days.png"} 
									style={{
										width: 28,
										height: 28,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
									borderRadius: 12,
									paddingTop: 17,
									paddingBottom: 17,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/e59xongt_expires_30_days.png"} 
									style={{
										width: 40,
										height: 40,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Phone Support"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Call Us: +123 456 7890"}
									</span>
								</div>
								<div 
									style={{
										width: 131,
										alignSelf: "stretch",
									}}>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lxws7mn3_expires_30_days.png"} 
									style={{
										width: 28,
										height: 28,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
									borderRadius: 12,
									paddingTop: 17,
									paddingBottom: 17,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 28,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hxjr6mhy_expires_30_days.png"} 
									style={{
										width: 40,
										height: 40,
										marginRight: 16,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										gap: 6,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Live Chat"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Chat with Us"}
									</span>
								</div>
								<div 
									style={{
										width: 71,
										alignSelf: "stretch",
									}}>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/f8kxh1ed_expires_30_days.png"} 
									style={{
										width: 28,
										height: 28,
										objectFit: "fill",
									}}
								/>
							</div>
							<span 
								style={{
									color: "#010101",
									fontSize: 18,
									fontWeight: "bold",
									marginBottom: 20,
								}} >
								{"Contact Form"}
							</span>
							<input
								placeholder={"Full Name"}
								value={input3}
								onChange={(event)=>onChangeInput3(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 16,
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 20,
									paddingRight: 20,
								}}
							/>
							<input
								placeholder={"Email Address"}
								value={input4}
								onChange={(event)=>onChangeInput4(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 16,
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 20,
									paddingRight: 20,
								}}
							/>
							<button 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 14,
									paddingBottom: 14,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 16,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 564,
									}} >
									{"Subject"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ywlpbq4p_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
							</button>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 70,
									paddingLeft: 20,
									paddingRight: 485,
									marginBottom: 16,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
									}} >
									{"Write your message here..."}
								</span>
							</div>
							<button 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
									borderRadius: 12,
									border: "none",
									paddingTop: 24,
									paddingBottom: 24,
									paddingLeft: 303,
									paddingRight: 303,
									marginBottom: 28,
									gap: 3,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/y4hgnjmd_expires_30_days.png"} 
									style={{
										width: 24,
										height: 24,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6BD0F6",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Attach File"}
								</span>
							</button>
							<button 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									border: "none",
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 294,
									paddingRight: 294,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Submit"}
								</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}